// @flow
import React, { Fragment } from 'react';
import type { ProductSequence } from 'store/modules/products';
import { resizeImage, numberWithCommas } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';

import cx from 'classnames';

import './ProductSequences.scss';

type ProductSequenceItemProps = {
  sequence: ProductSequence,
  username: string,
  active: boolean,
  thumbnail: string,
};

type Props = {
  sequences: ?(ProductSequence[]),
  username: string,
  currentProductId: string,
  displayName: string,
};

const ProductSequenceItem = ({
  sequence,
  username,
  active,
  thumbnail,
}: ProductSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/products/${url_slug}`;
  const imgUrl = resizeImage(thumbnail, 150, 150);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  return (
    <FakeLink className={cx('ProductSequenceItem', { active })} to={to}>
      <Link className="link" to={to}>
        <div className="mini-postcard">
          {thumbnail && (
            <Fragment>
              <div className="thumbnail">
                <img src={resizeImage(thumbnail, 150, 150)} alt="thumbnail" />
              </div>
              <div className="separator" />
            </Fragment>
          )}
          <div className="product-info">
            <span className="brand-name">{meta.supplier}</span>
            <h4>{title}</h4>
            {!!(meta.price && meta.price !== '0' && meta.price !== 0) && (
              <div className="price">
                <span>
                  {numberWithCommas(meta.price)}
                  <span className="price-unit">원</span>
                </span>
              </div>
            )}
          </div>
        </div>
      </Link>
    </FakeLink>
  );
};

const ProductSequences = ({ sequences, username, displayName, currentProductId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="ProductSequences">
      <div className="wrapper">
        <h3 className="title">다른 상품 둘러보기</h3>
        {sequences.map(s => (
          <ProductSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentProductId}
            thumbnail={s.thumbnail}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductSequences;



// WEBPACK FOOTER //
// ./src/components/product/ProductSequences/ProductSequences.js